import { CommonInput, CommonModal } from "components";
import React, { useState } from "react";
import "../../assets/css/modal.css";
import toast from "react-hot-toast";
import { uploadBannerFiles } from "_services";

const UploadBannerModal = (props) => {
  let { closeModal, getBanner } = props;
  const [formValue, setFormValue] = useState({
    banner: "",
  });
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      let data = e.target.files[0];
      setFormValue((s) => ({ ...s, banner: data }));
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const onSubmitFunction = async () => {
    setLoading(false);
    try {
      const formData = new FormData();
      formData.append("banner", formValue?.banner);
      const res = await uploadBannerFiles(formData);

      if (res?.responseCode === 200) {
        closeModal(false);
        setLoading(false);
        getBanner();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const propsAddBanner = {
    ...props,
    isLoadding: loading,
    onSubmit: (e) => onSubmitFunction(e),
    disabled: loading,
  };

  return (
    <>
      <CommonModal {...propsAddBanner}>
        <div className="_endTr_body">
          <div className="singleDiv _fileType">
            <CommonInput
              type="file"
              onChange={(e) => handleFileChange(e)}
              accept=".png, .jpg"
              // error={formError?.file}
            />
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default UploadBannerModal;
